import { apiClient } from "./ApiClient"
import {notify} from '../components/utils';


const tokenInfo = JSON.parse(sessionStorage.getItem("persist:root"));

if(tokenInfo) {
    const token = JSON.parse(tokenInfo.AdminPortal).token
    if(token) {
        apiClient.defaults.headers.Authorization = 'Bearer ' + token
    }
}
apiClient.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (401 === error?.response?.status) {
        notify("نشست شما منقضی شده است لطفا دوباره وارد شوید");
        sessionStorage.clear();
        apiClient.defaults.headers.Authorization = null;

    } else {
        return Promise.reject(error);
    }
});

export const adminLogin = (adminData) => apiClient.post(`/client/transaction/V2/verify-admin`, adminData)

export const updateService = (serviceData) => apiClient.post('/client/transaction/V2/update-service-info', serviceData)